import { Component } from '@poa/core';
import { action, observable } from '@poa/state';
import { ACCESS_LEVEL, GRANTED_HOSTS } from '../../store/auth/auth.constants';

import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import AccountGeneralInfo from './tabs/general-info';
import AccountHistory from './tabs/history';
import AccountIncome from './tabs/income';
import AccountPassword from './tabs/passwords';
import AccountRequisites from './tabs/requisites';
import AccountOperatorInfo from './tabs/operators';
import AccountGallary from './tabs/gallary';
import TrialLinkList from './tabs/trial-links';
import TrackingLinkList from './tabs/tracking-links';
import ClientTransferList from './tabs/client-transfer-list';
import DialogsList from './tabs/dialogs';
import AiReport from './tabs/ai';

import { getProfileIcon } from '../icons/profile';


const modalEl = document.getElementById('modal');

export class GeneralAccountModal extends React.Component {

    static defaultProps = {
        isOpened: true,
        linkId: 0
    };

    render() {
        const { isOpened, ...rest } = this.props;

        if (isOpened) {
            return ReactDOM.createPortal(<Modal {...rest} />, modalEl);
        }

        return null;
    }
}

const Modal = Component()(

    class Modal extends React.Component {
        store; // injected by Poa
        actions; // injected by Poa
        env; // injected by Poa
        t; // injected by Poa

        componentWillUnmount() {
            document.body.classList.remove('no-scroll');
            this.store.accounts.reports = [];
            this.store.accounts.isEdit = false;
        }

        async componentDidMount() {

            if (!this.props.accountId || this.props.accountId === null) {
                this.onClose();;
            } else {

                try {
                    this.localState.loading = true;
                    await this.actions.accountsActions.fetchAccount(this.props.accountId);
                    this.localState.loading = false;
                    document.body.classList.add('no-scroll');
                } catch (e) {
                    console.error(e);
                    this.onClose();
                }
            }
        }

        handleEditButtonClick = () => {
            this.store.accounts.isEdit = true;
            this.store.accounts.model = JSON.parse(JSON.stringify(this.store.accounts.originalModel));
            this.localState.isEdit = true;
        }

        handleSaveButtonClick = async () => {
            try {
                await this.actions.accountsActions.updateAccount(this.store.accounts.model);
                this.store.accounts.isEdit = false;
                this.localState.isEdit = false;
            } catch (e) {
                console.error(e);
            }
        }

        handleCancelButtonClick = () => {
            this.store.accounts.isEdit = false;
            this.localState.isEdit = false;
        }

        localState = observable({
            loading: false,
            activeTabIndex: 0,
            isEdit: false,

            getProps: () => this.props,

        });

        onClose = action(() => {
            this.store.accounts.isEdit = false;
            this.localState.isEdit = false;
            this.props.requestClose();
        });

        setActiveTabIndex = (index) => {
            this.localState.activeTabIndex = index;
        }

        render() {

            const { originalModel } = this.store.accounts;

            const handleTabClick = (index) => {
                if (originalModel !== null) {
                    this.setActiveTabIndex(index);
                } else {
                    return null;
                }
            }

            const generalTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 0
            });

            const historyTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 1
            });

            const incomeTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 2
            });

            const requisiteTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 3
            });

            const passwordTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 4
            });

            const operatorTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 5
            });

            const gallaryTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 6
            });

            const trialTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 7
            });

            const trackingTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 8
            });

            const clientTransferTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 9
            });

            const dialogsTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 10
            });

            const aiTabIsActiveClass = classNames('general_menu', {
                'general_menu--active': this.localState.activeTabIndex === 11
            });


            const tabs_indexes = {
                0: generalTabIsActiveClass,
                1: historyTabIsActiveClass,
                2: incomeTabIsActiveClass,
                3: requisiteTabIsActiveClass,
                4: passwordTabIsActiveClass,
                5: operatorTabIsActiveClass,
                6: gallaryTabIsActiveClass,
                7: trialTabIsActiveClass,
                8: trackingTabIsActiveClass,
                9: clientTransferTabIsActiveClass,
                10: dialogsTabIsActiveClass,
                11: aiTabIsActiveClass,
            }

            const tabsData = {
                0: <AccountGeneralInfo />,
                1: <AccountHistory />,
                2: <AccountIncome />,
                3: <AccountRequisites />,
                4: <AccountPassword />,
                5: <AccountOperatorInfo />,
                6: <AccountGallary />,
                7: <TrialLinkList />,
                8: <TrackingLinkList />,
                9: <ClientTransferList />,
                10: <DialogsList />,
                11: <AiReport />,
            }

            const tabsNames = [
                "анкета",
                "История",
                "доход",
                "реквизиты",
                "пароли",
                "операторы",
                "галерея",
                this.t('links:trials'),
                this.t('links:trackings'),
                this.t('links:transfers'),
                "диалоги",
                "AI"
            ]

            const ofTabs = [
                this.t('links:trials'),
                this.t('links:trackings'),
                this.t('links:transfers')
            ]

            const visorTabs = [
                "доход",
                "операторы",
            ];

            return (
                <div className='general-account-modal-layout'>
                    <div ref={node => (this.node = node)} className='body'>
                        <div className='container-info'>
                            <div className='container-control'>
                                <div className='edit_buttons'>
                                    {
                                        !this.localState.isEdit ?
                                            <button
                                                onClick={this.handleEditButtonClick}
                                                className='edit-button'>
                                                {getProfileIcon('pencil')}
                                            </button> :
                                            <div>
                                                <button
                                                    onClick={this.handleSaveButtonClick}
                                                    className='edit-button-active'>
                                                    Cохранить
                                                </button>
                                                <button
                                                    onClick={this.handleCancelButtonClick}
                                                    className='edit-button-cancel'>
                                                    Отмена
                                                </button>
                                            </div>
                                    }
                                </div>
                                <button className='close_button' onClick={this.onClose}>
                                    {this.t('common:close')}
                                </button>
                            </div>
                            <div className="general_info__header">
                                <ul className='menu'>
                                    {tabsNames.map((tab, idx) => {

                                        if (this.store.auth.currentHost !== GRANTED_HOSTS.of && ofTabs.includes(tab)) {
                                            return null;
                                        }

                                        if (this.store.auth.accessLevel === ACCESS_LEVEL.agency) {
                                            return (
                                                <li key={idx}>
                                                    <p
                                                        onClick={() => handleTabClick(idx)}
                                                        className={tabs_indexes[idx]}>
                                                        {tab}
                                                    </p>
                                                </li>
                                            );
                                        } else {
                                            if (ofTabs.includes(tab)) {
                                                return null;
                                            } else {

                                                if (this.store.auth.accessLevel === ACCESS_LEVEL.visor && visorTabs.includes(tab)) {

                                                    console.log('visorTabs', tab);
                                                    return null;
                                                }
                                                return (
                                                    <li key={idx}>
                                                        <p
                                                            onClick={() => handleTabClick(idx)}
                                                            className={tabs_indexes[idx]}>
                                                            {tab}
                                                        </p>
                                                    </li>
                                                );
                                            }

                                        }
                                    })}
                                </ul>
                            </div>
                            {tabsData[this.localState.activeTabIndex]}
                        </div>
                    </div>
                </div>
            );
        }
    }
);
